export const EVENT_CALENDAR = "EVENT_CALENDAR";
export const EVENT_CALENDAR_CLEAN = "EVENT_CALENDAR_CLEAN";
export const EVENT_CALENDAR_ERROR = "EVENT_CALENDAR_ERROR";
export const EVENT_CALENDAR_HIDE_ERROR = "EVENT_CALENDAR_HIDE_ERROR";
export const EVENT_CALENDAR_START_LOADER = "EVENT_CALENDAR_START_LOADER";
export const EVENT_CALENDAR_STOP_LOADER = "EVENT_CALENDAR_STOP_LOADER";
